export default (fabricCompositions, totalLines = 11) => {
      const originalLines = fabricCompositions.flatMap((part) => [
        part.garmentPart ? `${part.garmentPart.en} \n` : '',
        ...part.compositions.map((mat) => `${mat.percentage}% ${mat.name} \n`)
      ]).filter((part) => part)
      if (fabricCompositions.length === 1) {
        originalLines.splice(0, 1)
      }
      const missingLines = totalLines - originalLines.length
      if (missingLines > 0) {
        const topPadding = Math.floor(missingLines / 2)
        const bottomPadding = missingLines - topPadding
        return {
          textLine: originalLines.length,
          labels: [
            ...Array(topPadding).fill('\n'),
            ...originalLines,
            ...Array(bottomPadding).fill('\n')
          ].join('').toUpperCase()
        }
      }
      if (missingLines === 0) {
        return {
          textLine: originalLines.length,
          labels: [...originalLines].join('').toUpperCase()
        }
      }
      return { textLine: originalLines.length, labels: originalLines.slice(0, 11).join('').toUpperCase() }
}
